<template>
    <transition appear name="fade-transition">
        <div :class="classList">
            <v-autocomplete
                ref="input"
                v-model="inputValue"
                v-test-id
                name="currency"
                :hide-details="hideDetails || _.isEmpty(rulesValue)"
                :label="labelValue"
                :items="items"
                :required="required"
                :rules="rulesValue"
                :error-messages="errorMessagesValue"
                :clearable="!required"
                :loading="searchLoading"
                :disabled="disabled"
                background-color="background"
                color="primaryText"
                item-color="primaryText"
                outlined
                dense
                :class="{ 'mb-7': _.isEmpty(rulesValue) }"
                :filter="filterItems"
                cache-items
                open-on-clear
                @focus="$emit('focus')"
                @blur="$emit('blur')"
                @keyup="$emit('keyup')"
                @keydown="$emit('keydown')"
                @click="$emit('click')"
            >
                <template #selection="{ item }">
                    <v-list-item class="field__currency--selected-item px-1">
                        <!-- <v-img :src="item.flag" contain width="1.4rem" class="flex-grow-0 mr-2" /> -->
                        <v-list-item-content>
                            <v-list-item-title> {{ item.name }} ({{ item.code }} {{ item.symbol }}) </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
                <template #item="{ item, on, attrs }">
                    <v-list-item
                        :disabled="attrs.disabled"
                        :role="attrs.role"
                        :class="{
                            'primaryText--text': inputValue && inputValue.code === item.code,
                            'v-list-item--active': inputValue && inputValue.code === item.code
                        }"
                        v-on="on"
                    >
                        <!-- <v-img :src="item.flag" contain width="1.4rem" class="flex-grow-0 mr-2" /> -->
                        <v-list-item-content>
                            <v-list-item-title> {{ item.name }} ({{ item.code }} {{ item.symbol }}) </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-autocomplete>
        </div>
    </transition>
</template>

<script>
import BaseField from './BaseField';
import i18n from '@/lib/i18n';
import countries from '@/mixins/countries';
import i18nMixin from '@/mixins/i18n';

export default {
    name: 'Country',
    extends: BaseField,
    mixins: [countries, i18nMixin],
    props: {
        outlined: {
            type: Boolean,
            default: true
        },
        returnObject: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        labelText: i18n.t('currency'),
        searchLoading: false,
        items: []
    }),
    computed: {
        inputValue: {
            get() {
                if (this._.isString(this.value)) {
                    return this.items.find(item => item.code === this.value);
                }
                return this.value;
            },
            set(value) {
                if (!value || this.returnObject) {
                    this.$emit('input', value);
                } else {
                    this.$emit('input', value.code);
                }
            }
        },
        classList() {
            const name = 'field__currency';

            let classList = [name];

            if (this.form) {
                classList.push(`${name}--form`);
            }

            if (this.label) {
                classList.push(`${name}--label`);
            }

            if (this.hint) {
                classList.push(`${name}--hint`);
            }

            if (this.description) {
                classList.push(`${name}--description`);
            }

            if (this.required) {
                classList.push(`${name}--required`);
            }

            if (this.disabled) {
                classList.push(`${name}--disabled`);
            }

            if (this.readonly) {
                classList.push(`${name}--readonly`);
            }

            if (!this.isValid) {
                classList.push(`${name}--error`);
            }

            return classList.join(' ');
        }
    },
    methods: {
        async setup() {
            this.searchLoading = true;

            if (!this.localeLoading) {
                await this.loadLocale();
            }

            this.items = this.countries
                .map(({ currency, flag }) => ({
                    code: currency.code,
                    name: currency.name,
                    symbol: currency.symbol,
                    flag
                }))
                .filter(item => item.code && item.name && item.symbol && item.flag);

            this.items = this.items.filter((item, index, self) => self.findIndex(t => t.code === item.code) === index);

            if (!this.value) {
                this.inputValue = this.items[0];
            }

            this.searchLoading = false;
        },
        filterItems(item, queryText) {
            if (!queryText) {
                return true;
            }
            if (item.code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1) {
                return true;
            }
            if (item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1) {
                return true;
            }
            if (item.symbol.indexOf(queryText) > -1) {
                return true;
            }
            return false;
        }
    }
};
</script>

<style lang="scss" scoped>
.field__currency {
    .v-text-field.v-input--dense {
        margin-top: 0;
    }

    .v-select--is-menu-active .field__currency--selected-item {
        display: none;
    }
}
</style>
